import React from 'react';
import {
	FormControl,
	FormControlLabel,
	Grid,
	Switch,
	TextField,
	Typography,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { useGlobalization } from '@Translations';
import { RehabAction } from '@Types';

interface RehabActionFieldProps {
	rehabActions: RehabAction[];
	selectedActionId: string;
	locked: boolean;
	disabled: boolean;
	onActionChange: (actionId: string) => void;
	onLockToggle: () => void;
}

export const RehabActionField = ({
	rehabActions,
	selectedActionId,
	locked,
	disabled,
	onActionChange,
	onLockToggle,
}: RehabActionFieldProps) => {
	const { t } = useGlobalization();
	return (
		<>
			<Grid xs={12} item>
				<FormControl
					variant="outlined"
					margin="normal"
					fullWidth
					disabled={disabled}>
					<Autocomplete
						id="rehabAction"
						disableClearable
						disabled={disabled}
						options={
							rehabActions?.map(action => action.actionId) ?? []
						}
						getOptionLabel={option => option}
						defaultValue={selectedActionId}
						onChange={(_event, newValue) =>
							onActionChange(newValue ?? '')
						}
						renderInput={params => (
							<TextField
								{...params}
								variant="outlined"
								label={t('Rehab Action')}
							/>
						)}
					/>
				</FormControl>
			</Grid>
			<Grid xs={12} item>
				<FormControlLabel
					control={
						<Switch
							size="small"
							checked={locked}
							disabled={disabled}
							onChange={onLockToggle}
						/>
					}
					label={t('Lock this action')}
				/>
				<Typography style={{ fontSize: '12px', color: '#768D95' }}>
					{t(
						'Locking the rehab action will prevent manual override of assigned action/cost. This will also prevent changes to the assigned action when the decision tree is run.',
					)}
				</Typography>
			</Grid>
		</>
	);
};
